var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram",
    clipPath: "url(#clip-Instagram)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10834",
    "data-name": "Group 10834",
    transform: "translate(1 1.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(0 -0.411)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10831",
    "data-name": "Group 10831",
    transform: "translate(5.806 5.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11592",
    "data-name": "Path 11592",
    d: "M23.563,754.553c1.306,0,1.462,0,1.979.029a2.658,2.658,0,0,1,.909.169,1.627,1.627,0,0,1,.928.928,2.659,2.659,0,0,1,.169.909c.025.516.029.673.029,1.979s0,1.462-.029,1.978a2.659,2.659,0,0,1-.169.909,1.626,1.626,0,0,1-.928.928,2.658,2.658,0,0,1-.909.169c-.516.025-.67.029-1.979.029s-1.462,0-1.979-.029a2.658,2.658,0,0,1-.909-.169,1.627,1.627,0,0,1-.917-.93,2.659,2.659,0,0,1-.169-.909c-.025-.516-.029-.673-.029-1.979s0-1.462.029-1.979a2.659,2.659,0,0,1,.169-.909,1.627,1.627,0,0,1,.917-.917,2.66,2.66,0,0,1,.909-.169c.516-.025.673-.029,1.979-.029m0-.882c-1.329,0-1.5,0-2.018.029a3.6,3.6,0,0,0-1.189.228,2.489,2.489,0,0,0-1.44,1.44,3.6,3.6,0,0,0-.228,1.189c-.023.522-.029.689-.029,2.018s0,1.5.029,2.018a3.6,3.6,0,0,0,.247,1.17,2.488,2.488,0,0,0,1.44,1.44,3.6,3.6,0,0,0,1.189.228c.522.023.689.029,2.018.029s1.5,0,2.018-.029a3.6,3.6,0,0,0,1.189-.228,2.488,2.488,0,0,0,1.44-1.44,3.6,3.6,0,0,0,.228-1.189c.023-.522.029-.689.029-2.018s0-1.5-.029-2.018a3.6,3.6,0,0,0-.228-1.189,2.489,2.489,0,0,0-1.44-1.44,3.6,3.6,0,0,0-1.189-.228c-.522-.023-.689-.029-2.018-.029Z",
    transform: "translate(-18.66 -753.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11593",
    "data-name": "Path 11593",
    d: "M32.793,765.28a2.513,2.513,0,1,0,2.513,2.513A2.513,2.513,0,0,0,32.793,765.28Zm0,4.144a1.631,1.631,0,1,1,1.631-1.631,1.631,1.631,0,0,1-1.631,1.631Z",
    transform: "translate(-27.89 -762.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1055",
    "data-name": "Ellipse 1055",
    cx: 0.588,
    cy: 0.588,
    r: 0.588,
    transform: "translate(6.927 1.703)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.829a38d5e5b807e2df05b9ddc85f6d27.svg";
export { ForwardRef as ReactComponent };